import React from 'react';
import './styles.css';
import LandingPage from './LandingPage';

const App: React.FC = () => {
  return (
    <div className="App">
      <LandingPage />
    </div>
  );
};

export default App;
